export default __webpack_public_path__ + "static/media/sample bar.238721d7.PNG";